import React from 'react';
import {AuthedLayout} from 'components/Layout';

const LiveRoleInvitationLazy = React.lazy(() => import(/* webpackChunkName: "LiveRoleInvitation" */ './LiveRoleInvitation'));

export const LiveRoleInvitation = props => <AuthedLayout component={LiveRoleInvitationLazy} {...props} />;
